import {
  IsString,
  IsEmail,
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsUUID,
  IsDateString,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class CreateUserDto {
  @ApiProperty({
    example: 'admin@opb.com',
    description: 'Email del usuario',
  })
  @IsEmail()
  readonly email!: string;

  @ApiProperty({
    example: 'John',
    description: 'Nombre del usuario',
  })
  @IsString()
  @IsNotEmpty()
  readonly firstName!: string;

  @ApiProperty({
    example: 'Doe',
    description: 'Apellido del usuario',
  })
  @IsString()
  @IsNotEmpty()
  readonly lastName!: string;

  @ApiProperty({
    example: 'password123',
    description:
      'Contraseña del usuario (mínimo 8 caracteres, incluir mayúsculas, números y caracteres especiales)',
  })
  @IsString()
  @IsNotEmpty()
  readonly password!: string;
}

export class UpdateUserDto {
  @ApiPropertyOptional({
    example: 'admin@opb.com',
    description: 'Email del usuario',
  })
  @IsOptional()
  @IsEmail()
  readonly email?: string;

  @ApiPropertyOptional({
    example: 'Admin',
    description: 'Nombre del usuario',
  })
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  readonly firstName?: string;

  @ApiPropertyOptional({
    example: 'Doe',
    description: 'Apellido del usuario',
  })
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  readonly lastName?: string;
}

export class LoginUserDto {
  @ApiProperty({
    example: 'admin@opb.com',
    description: 'Email del usuario',
  })
  @IsEmail()
  readonly email!: string;

  @ApiProperty({
    example: 'password123',
    description: 'Contraseña del usuario',
  })
  @IsString()
  @IsNotEmpty()
  readonly password!: string;
}

export class UserResponseDto {
  @ApiProperty({
    example: '123e4567-e89b-12d3-a456-426614174000',
    description: 'ID único del usuario',
  })
  @IsUUID()
  readonly id!: string;

  @ApiProperty({
    example: 'admin@opb.com',
    description: 'Email del usuario',
  })
  @IsEmail()
  readonly email!: string;

  @ApiProperty({
    example: 'John',
    description: 'Nombre del usuario',
  })
  @IsString()
  readonly firstName!: string;

  @ApiProperty({
    example: 'Doe',
    description: 'Apellido del usuario',
  })
  @IsString()
  readonly lastName!: string;

  @ApiProperty({
    example: true,
    description: 'Indica si el usuario está activo',
  })
  @IsBoolean()
  readonly isActive!: boolean;

  @ApiProperty({
    example: '2024-01-15T10:30:00Z',
    description: 'Fecha de creación del usuario',
  })
  @IsDateString()
  readonly createdAt!: string;

  @ApiPropertyOptional({
    example: '2024-01-15T10:30:00Z',
    description: 'Fecha de última actualización',
  })
  @IsOptional()
  @IsDateString()
  readonly updatedAt?: string;

  @ApiPropertyOptional({
    example: '2024-01-15T10:30:00Z',
    description: 'Fecha del último login',
  })
  @IsOptional()
  @IsDateString()
  readonly lastLoginAt?: string;
}
